import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";

const CHECK_EVERY_MS = 15 * 60_000;

/** Registers the service worker; a new version waits until the user chooses to reload, never mid-sale. */
export function UpdateBanner() {
  const { t } = useI18n();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    // Tabs stay open for days at a till; without asking, they would never notice a new release.
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => {
        if (navigator.onLine) void registration.update().catch(() => undefined);
      };
      setInterval(check, CHECK_EVERY_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
      });
    },
  });
  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-20 z-50 mx-auto flex max-w-md items-center justify-between gap-3 rounded-lg border bg-card p-3 text-sm shadow-lg md:bottom-4"
    >
      <span>{t("pwa.updateReady")}</span>
      <div className="flex gap-2">
        <Button variant="ghost" size="sm" onClick={() => setNeedRefresh(false)}>
          {t("ui.close")}
        </Button>
        <Button size="sm" onClick={() => void updateServiceWorker(true)}>
          {t("pwa.reload")}
        </Button>
      </div>
    </div>
  );
}
